const calcTriangleHeight = (width: number): number => {
  return 0.5 * Math.sqrt(3) * width
}

export default calcTriangleHeight
